import React, { useEffect } from 'react';
import './stylesheets/App.scss';
import {
  Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import * as routes from './constants/routes';
import OnboardingPage from './components/OnboardingPage.jsx';
import SchedulesPage from './components/SchedulesPage.jsx';
import LandingPage from './components/LandingPage.jsx';
import SettingsPage from './components/Settings.jsx';
import { SessionContextProvider } from './components/SessionContext';
import { MixpanelProvider } from 'react-mixpanel';
import mixpanel from 'mixpanel-browser';
import { createBrowserHistory } from 'history';

// adapted from nest
let previousLocationData = null
const historyListener = (location, action, skipTracking) => {
  const data = {"Path": location.pathname, "Query string": location.search, "Previous path": previousLocationData ? previousLocationData.path : null}

  if(!skipTracking) {
    mixpanel.track('WFH_Navigation', Object.entries(data).reduce((buffer, [ key, value ]) =>
      value ? Object.assign(buffer, {[key]: value}) : buffer,
    {}));

    window.Appcues.page()
  }

  // if(process.env.REACT_APP_ENVIRONMENT === 'production' && window.gtag) {
  //   window.gtag('config', 'G-LDXFPF3FCH', {
  //     'page_location': window.location.href,
  //     'page_path': location.pathname,
  //   })
  // }

  previousLocationData = data
}


const history = createBrowserHistory()
// Run on the initial page load.
historyListener(window.location, null, true);

// Run on location change.
history.listen(historyListener);

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

// for debugging mixpanel tracking, uncomment below
// const oldMixpanelTrack = mixpanel.track.bind(mixpanel)
// mixpanel.track = (eventName, data) => {
//   console.log(eventName, data)
//   oldMixpanelTrack(eventName, data)
// }

function App() {
  return (
    <MixpanelProvider mixpanel={mixpanel}>
        <SessionContextProvider>
          <Router history={history}>
            <Switch>
              <Route exact path={routes.ROOT}>
                <h1>{process.env.GRAPHQL_ENDPOINT}</h1>
                <LandingPage />
              </Route>
              <Route path={routes.SCHEDULES}>
                <SchedulesPage />
              </Route>
              <Route path={routes.ONBOARDING}>
                <OnboardingPage />
              </Route>
              <Route path={routes.SETTINGS}>
                <SettingsPage />
              </Route>
            </Switch>
          </Router>
      </SessionContextProvider>
    </MixpanelProvider>
  );
}
export default App;
